var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.05C9 3.88431 9.13431 3.75 9.3 3.75H20.7C20.8657 3.75 21 3.88431 21 4.05V6.45C21 6.61569 20.8657 6.75 20.7 6.75H9.3C9.13432 6.75 9 6.61569 9 6.45V4.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.55C4.5 8.38431 4.63431 8.25 4.8 8.25H20.7C20.8657 8.25 21 8.38431 21 8.55V10.95C21 11.1157 20.8657 11.25 20.7 11.25H4.8C4.63431 11.25 4.5 11.1157 4.5 10.95V8.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.05C6 12.8843 6.13431 12.75 6.3 12.75H20.7C20.8657 12.75 21 12.8843 21 13.05V15.45C21 15.6157 20.8657 15.75 20.7 15.75H6.3C6.13432 15.75 6 15.6157 6 15.45V13.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.55C3 17.3843 3.13431 17.25 3.3 17.25H20.7C20.8657 17.25 21 17.3843 21 17.55V19.95C21 20.1157 20.8657 20.25 20.7 20.25H3.3C3.13431 20.25 3 20.1157 3 19.95V17.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentRight);
export default __webpack_public_path__ + "static/media/alignment-right.63407a7c65bbc8e1fa28837dce61acde.svg";
export { ForwardRef as ReactComponent };